<template>
  <div class="processing-status">
    <span class="text-muted" v-if="saving && !saved">
      Saving <i class="fas fa-spinner fa-spin"></i>
    </span>
    <span class="text-muted" v-if="saved">
      Saved! <i class="fas fa-check"></i>
    </span>
  </div>
</template>
<script>
export default {
  name: 'processing-spinner',
  props: ['saving', 'saved']
}
</script>
<style scoped>
.processing-status {
  margin-left: 10px;
}
</style>
